
import React from "react";
import ReactDOM from "react-dom/client";
import Snapper from "../../../../../shared/Snapper";
import { i18nManager } from "../../../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Elements } from "../../../../../shared/Elements";
import { Schemes, Utils } from "../../../../../../utils";
import { AlertInterface, BoolHelper, ButtonManageRef, Checkbox, Classname, Column, DOMHelper, FormControl, ObjectHelper, RadioButton, Scheme, Table, TableSelectionMode, TextAreaInput, TextInput } from "@rivtn/noseur";
import { ApiResponseData, EarningService, ITournamentEditionRegisteredParticipant, ITournamentEdition, ITransaction, RegisteredTournamentStatus, TournamentService, TransactionType, RegisteredTournamentParticipantType, TeamService, SanitizedResponse, ITournamentEditionPrize, BaseService } from "../../../../../../services";
import { ConfirmDialog, Siren } from "../../../../../shared/ConfirmDialog";
import { profile } from "console";
import { buildJoinTournamentHeader } from "../../../../tournaments/RegisterForTournament";
import PrizePoolDetail from "../shared/PrizePoolDetail";

interface HistoricPrizePoolProps {
    snapTournament?: () => void;
    tournamentEdition: ITournamentEdition;
    dataComponentState?: [React.ReactElement | undefined, React.Dispatch<React.SetStateAction<React.ReactElement | undefined>>];
}

function HistoricPrizePool(props: HistoricPrizePoolProps) {

    const { tournamentEdition } = props;
    const tournamentService = TournamentService.getInstance();
    const activeDialogMutableRoot = React.useRef<ReactDOM.Root>(null);
    const [dataComponent, setDataComponent] = props.dataComponentState ?? [];
    const labels = i18nManager.Labels.host.manage_tournament.result_prize_distro;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [tournamentPrizes, setTournamentPrizes] = React.useState<ApiResponseData<ITournamentEditionPrize> | undefined>({});

    React.useEffect(() => {
        fetchInformation();

        return () => {
            setDataComponent?.(undefined);
        };
    }, []);

    return (<div className="mt-participants">
        <div className="mt-participants-navbar">
            <div className="l" style={{ display: "flex", alignItems: "center" }}>
                <i className="fa fa-arrow-left" style={{ cursor: "pointer" }} onClick={() => window.history.back()} />
                <span className="lined-limit" style={{ fontSize: 16, marginLeft: 10 }}>{labels.historic_prize_pool}</span>
            </div>
            <div style={{ alignItems: "center" }}>
                <span className="link">{labels.export}</span>
                <Snapper header={labels.historic_prizes_media_snap} template={[{ p: "tour_name", v: tournamentEdition.name }]} />
            </div>
        </div>
        <div className="mt-query-section">
            {Elements.buildConfirmDialogForm(labels.query_inputs, (name, value) => {
                Utils.updateSearchParams(name, value, setSearchParams, fetchInformation);
            }, {}, undefined, { flex: 0.5, marginTop: 10, flexDirection: "row", alignItems: "center" }, undefined, {
                marginRight: 15, marginTop: 0
            })}
        </div>
        <div className="mt-table-compound">
            <Table stripedRows scheme={Schemes.OMNEHOST} data={tournamentPrizes?.content} totalRecords={tournamentPrizes?.total_elements} dataRefreshKeys={["external_id", "created_at", "status"]}
                style={{ flex: 1, width: "100%" }} rowsPerPage={parseInt(searchParams.get("size") ?? "100")} loadingState={Elements.LOADING_STATE}
                emptyState={Elements.buildEmptyListView("fa fa-users", (<span>
                    {labels.table.empty_label_parts.have_no}{" "}
                    <span className="link" onClick={() => { }}>{labels.table.empty_label_parts.add_new}</span>{" "}
                </span>), { marginTop: 150 })} selectionMode={TableSelectionMode.SINGLE} rowSelection={true} valuedRowProps={(d) => {
                    return {
                        className: Classname.build("host-tour-row", { "active": (dataComponent as any)?.key === d?.external_id })
                    };
                }} onRowSelection={(tournamentPrize) => {
                    Utils.updateSearchParams("sprize", tournamentPrize.external_id, setSearchParams);
                    setDataComponent?.(PrizePoolDetail({ distributed: true, tournamentEdition, tournamentPrize, dataComponentState: props.dataComponentState, refetch: fetchInformation, setSearchParams }));
                    return false;
                }}>
                <Column className="table-c" header={labels.table.headers.type} dataKey="type" template={(v) => Utils.toSaneSentenceFormat(v)} />
                <Column className="table-c" doNotRender={!!dataComponent} header={labels.table.headers.name} template={(v) => {
                    return (v.type === "TROPHY" ? v.title : `${Utils.numberWithNth(v.position)} ${labels.top_winner}`);
                }} />
                <Column className="table-c" header={labels.table.headers.winner} dataKey="winner" template={(v) => {
                    //const name = Utils.getResourceName(v);

                    return (<div style={{ display: "flex", alignItems: "center" }}>
                        <img alt={"name"} src={"https://upload.wikimedia.org/wikipedia/en/5/5c/Panda_Z.gif"} style={{ width: 20, height: 20, borderRadius: "100%", marginRight: 5 }} />
                        <span>{"The Royals"}</span>
                    </div>)
                }} />
                <Column className="table-c" doNotRender={!!dataComponent} header={labels.table.headers.monetary_prize} dataKey="monetary_prize_rewarded" template={(v) => {
                    return (`${i18nManager.getCurrencySign("NGN")} 45,000.00`);
                }} />
                <Column className="table-c" doNotRender={!!dataComponent} header={labels.table.headers.presentment_date} dataKey="presentment_date" template={(v) => Utils.formatToFineDate(v, true)} />
                <Column className="table-c" doNotRender={!!dataComponent} template={(v) => (<div style={{ display: "flex", alignItems: "center" }}>
                    <i className="fa fa-angle-right" />
                </div>)} />
            </Table>
            <div className="pagination">
                {Elements.buildPaginator(tournamentPrizes ?? {},
                    ({ currentPage }, size) => Utils.updateSearchParamses({ "page": currentPage, size }, setSearchParams, fetchInformation),
                    parseInt(searchParams.get("page") ?? "1"), { margin: 15, marginBottom: 5 })}
                {Elements.buildSorter(labels.table.sorts, (sort) => Utils.updateSearchParamses({ sort }, setSearchParams, fetchInformation), labels.table.sorts[0].label)}
            </div>
        </div>
    </div>);

    function fetchInformation() {
        tournamentService.getTournamentEditionPrizePool(tournamentEdition.external_id!).then(({ apiResponse }: SanitizedResponse<ITournamentEditionPrize>) => {
            setTournamentPrizes(apiResponse.data);
        }).catch(BaseService.reportError);
    }

    function buildStatusLabel(status: RegisteredTournamentStatus) {
        const color = {
            [RegisteredTournamentStatus.REMOVED]: "#0D0D0D",
            [RegisteredTournamentStatus.WITHDRAWN]: "#D55C5C",
            [RegisteredTournamentStatus.REGISTERED]: "#49C564",
        }[status];
        const label = labels.query_inputs.find((i) => i.name === "status")?.options?.find((o) => o.value === status)?.label ?? status;
        return (<span style={{ fontWeight: "bold", color }}>{label}</span>);
    }

}

export default HistoricPrizePool;
